import { I18nLocale, LOCALE } from 'utils';

export const ROUTE = {
  HOME: 'HOME',
  CONTACT: 'CONTACT',
  ABOUT: 'ABOUT',
  DELIVERY: 'DELIVERY',
  PAYMENTS: 'PAYMENTS',
  CART: 'CART',
  CHECKOUT: 'CHECKOUT',
  CHECKOUT_STATUS: 'CHECKOUT_STATUS',
  SINGLE_PRODUCT: 'SINGLE_PRODUCT',
  PRODUCTS_LIST: 'PRODUCTS_LIST',
  BRANDS_LIST: 'BRANDS',
  SINGLE_BRAND: 'SINGLE_BRAND',
  SEARCH: 'SEARCH',
  RULES: 'RULES',
  PRIVACY_POLICY: 'PRIVACY_POLICY',
  RETURN_COMPLAINT: 'RETURN_COMPLAINT',
  TRACK_ORDER: 'TRACK_ORDER',
  ACCOUNT_ORDERS: 'ACCOUNT_ORDERS',
  ACCOUNT_INFORMATION: 'ACCOUNT_INFORMATION',
  ACCOUNT_FORGOT_PASSWORD: 'ACCOUNT_FORGOT_PASSWORD',
  PROMOTIONS: 'PROMOTIONS',
  SELLOUTS: 'SELLOUTS',
  IN_POST_PAY: 'IN_POST_PAY',
  IMPRESSUM: 'IMPRESSUM',
} as const;

export const routes: Record<
  I18nLocale,
  Record<keyof typeof ROUTE, '|' | `/${string}`>
> = {
  [LOCALE.PL]: {
    HOME: '/',
    CONTACT: '/kontakt',
    ABOUT: '/o-nas',
    DELIVERY: '/sposoby-dostawy',
    PAYMENTS: '/sposoby-platnosci',
    CART: '/koszyk',
    CHECKOUT: '/checkout',
    CHECKOUT_STATUS: '/checkout/status',
    SEARCH: '/search',
    PRODUCTS_LIST: '/produkty',
    SINGLE_PRODUCT: '/produkt',
    BRANDS_LIST: '/marki',
    SINGLE_BRAND: '/marka',
    RULES: '/regulamin',
    PRIVACY_POLICY: '/polityka-prywatnosci',
    RETURN_COMPLAINT: '/zwroty-i-reklamacje',
    TRACK_ORDER: '/sledzenie-zamowienia',
    ACCOUNT_ORDERS: '/konto/moje-zamowienia',
    ACCOUNT_INFORMATION: '/konto/moje-dane',
    ACCOUNT_FORGOT_PASSWORD: '/konto/customer-forgot-password',
    PROMOTIONS: '/promocje',
    SELLOUTS: '/wyprzedaz',
    IN_POST_PAY: '/inpost-pay',
    IMPRESSUM: '/impressum',
  },
  [LOCALE.SK]: {
    HOME: '/',
    CONTACT: '/kontakt',
    ABOUT: '/o-nas',
    DELIVERY: '/sposoby-dorucenia',
    PAYMENTS: '/sposoby-platby',
    CART: '/kosik',
    CHECKOUT: '/checkout',
    CHECKOUT_STATUS: '/checkout/status',
    SEARCH: '/search',
    PRODUCTS_LIST: '/produkty',
    SINGLE_PRODUCT: '/produkt',
    BRANDS_LIST: '/znacky',
    SINGLE_BRAND: '/znacka',
    RULES: '/obchodne-podmienky',
    PRIVACY_POLICY: '/ochrana-osobnych-udajov',
    RETURN_COMPLAINT: '/vratenie-a-reklamacie',
    TRACK_ORDER: '/sledovanie-objednavky',
    ACCOUNT_ORDERS: '/konto/moje-zamowienia',
    ACCOUNT_INFORMATION: '/konto/moje-dane',
    ACCOUNT_FORGOT_PASSWORD: '/konto/customer-forgot-password',
    PROMOTIONS: '/specialna-ponuka',
    SELLOUTS: '/vypredaj',
    IN_POST_PAY: '/inpost-pay',
    IMPRESSUM: '/impressum',
  },
  [LOCALE.CZ]: {
    HOME: '/',
    CONTACT: '/kontakt',
    ABOUT: '/o-nas',
    DELIVERY: '/zpusoby-dopravy',
    PAYMENTS: '/zpusoby-platby',
    CART: '/cart',
    CHECKOUT: '/checkout',
    CHECKOUT_STATUS: '/checkout/status',
    SEARCH: '/search',
    PRODUCTS_LIST: '/produkty',
    SINGLE_PRODUCT: '/produkt',
    BRANDS_LIST: '/znacky',
    SINGLE_BRAND: '/znacka',
    RULES: '/obchodni-podminky',
    PRIVACY_POLICY: '/ochrana-osobnich-udaju',
    RETURN_COMPLAINT: '/vraceni-reklamace',
    TRACK_ORDER: '/sledovani-objednavky',
    ACCOUNT_ORDERS: '/konto/moje-zamowienia',
    ACCOUNT_INFORMATION: '/konto/moje-dane',
    ACCOUNT_FORGOT_PASSWORD: '/konto/customer-forgot-password',
    PROMOTIONS: '/specialni-nabidka',
    SELLOUTS: '/vyprodej',
    IN_POST_PAY: '/inpost-pay',
    IMPRESSUM: '/impressum',
  },
  [LOCALE.RO]: {
    HOME: '/',
    CONTACT: '/kontakt',
    ABOUT: '/o-nas',
    DELIVERY: '/sposoby-dostawy',
    PAYMENTS: '/sposoby-platnosci',
    CART: '/koszyk',
    CHECKOUT: '/checkout',
    CHECKOUT_STATUS: '/checkout/status',
    SEARCH: '/produkty/search',
    PRODUCTS_LIST: '/produkty',
    SINGLE_PRODUCT: '/produkt',
    BRANDS_LIST: '/marken',
    SINGLE_BRAND: '/marka',
    RULES: '/regulamin',
    PRIVACY_POLICY: '/polityka-prywatnosci',
    RETURN_COMPLAINT: '/zwroty-i-reklamacje',
    TRACK_ORDER: '/status-zamowienia',
    ACCOUNT_ORDERS: '/konto/moje-zamowienia',
    ACCOUNT_INFORMATION: '/konto/moje-dane',
    ACCOUNT_FORGOT_PASSWORD: '/konto/customer-forgot-password',
    PROMOTIONS: '/sonderangebot',
    SELLOUTS: '/ausverkauf',
    IN_POST_PAY: '/inpost-pay',
    IMPRESSUM: '/impressum',
  },
  [LOCALE.DE]: {
    HOME: '/',
    CONTACT: '/kontakt',
    ABOUT: '/ueber-uns',
    DELIVERY: '/versandarten',
    PAYMENTS: '/zahlungsarten',
    CART: '/warenkorb',
    CHECKOUT: '/checkout',
    CHECKOUT_STATUS: '/checkout/status',
    SEARCH: '/search',
    PRODUCTS_LIST: '/produkte',
    SINGLE_PRODUCT: '/produkt',
    BRANDS_LIST: '/marken',
    SINGLE_BRAND: '/marke',
    RULES: '/agb',
    PRIVACY_POLICY: '/datenschutz',
    RETURN_COMPLAINT: '/retoure-reklamation',
    TRACK_ORDER: '/sendungsverfolgung',
    ACCOUNT_ORDERS: '/konto/bestellungen',
    ACCOUNT_INFORMATION: '/konto/persoenliche-daten',
    ACCOUNT_FORGOT_PASSWORD: '/konto/passwort-vergessen',
    PROMOTIONS: '/sonderangebote',
    SELLOUTS: '/ausverkauf',
    IN_POST_PAY: '/inpost-pay',
    IMPRESSUM: '/impressum',
  },
};

export const authRoutes: Record<I18nLocale, string[]> = {
  [LOCALE.PL]: [
    routes[LOCALE.PL].ACCOUNT_ORDERS,
    routes[LOCALE.PL].ACCOUNT_INFORMATION,
  ],
  [LOCALE.SK]: [
    routes[LOCALE.SK].ACCOUNT_ORDERS,
    routes[LOCALE.SK].ACCOUNT_INFORMATION,
  ],
  [LOCALE.CZ]: [
    routes[LOCALE.CZ].ACCOUNT_ORDERS,
    routes[LOCALE.CZ].ACCOUNT_INFORMATION,
  ],
  [LOCALE.RO]: [
    routes[LOCALE.RO].ACCOUNT_ORDERS,
    routes[LOCALE.RO].ACCOUNT_INFORMATION,
  ],
  [LOCALE.DE]: [
    routes[LOCALE.DE].ACCOUNT_ORDERS,
    routes[LOCALE.DE].ACCOUNT_INFORMATION,
  ],
};

export const unAuthRoutes: Record<I18nLocale, string[]> = {
  [LOCALE.PL]: [routes[LOCALE.PL].ACCOUNT_FORGOT_PASSWORD],
  [LOCALE.SK]: [routes[LOCALE.PL].ACCOUNT_FORGOT_PASSWORD],
  [LOCALE.CZ]: [routes[LOCALE.PL].ACCOUNT_FORGOT_PASSWORD],
  [LOCALE.RO]: [routes[LOCALE.PL].ACCOUNT_FORGOT_PASSWORD],
  [LOCALE.DE]: [routes[LOCALE.PL].ACCOUNT_FORGOT_PASSWORD],
};
